// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__CJWus","gwcspinner":"styles_gwcspinner__Eh0bD","s":"styles_s__tjOWb","m":"styles_m__1cwQa","l":"styles_l__rCUqw"};